import { render, staticRenderFns } from "./InappBrowserWarningDialog.vue?vue&type=template&id=6aebf2f2&scoped=true"
import script from "./InappBrowserWarningDialog.vue?vue&type=script&lang=js"
export * from "./InappBrowserWarningDialog.vue?vue&type=script&lang=js"
import style0 from "./InappBrowserWarningDialog.vue?vue&type=style&index=0&id=6aebf2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aebf2f2",
  null
  
)

export default component.exports